// extracted by mini-css-extract-plugin
module.exports = {"button":"_2JEAeW","background":"_3KFpBh","on":"_1jin6x","checkmark":"YkZrnF","name":"_399ZWM"};